import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField';
import { Button, Grid } from '@material-ui/core';
import Timeline from '@material-ui/lab/Timeline';
import HeaderTimeline from '../layouts/Timeline/HeaderTimeline'
import ContactsIcon from '@material-ui/icons/Contacts';
import CustomTimeline from '../layouts/Timeline/CustomTimelineItem'
import Enddot from '../layouts/Timeline/Enddot'
import GoogleMap from '../map/SimpleMap';
import axios from 'axios';
import Alert from '@material-ui/lab/Alert';
import { useStyles } from './styles';

const Contact = () => {
    const classes = useStyles();
    const [status, setStatus] = useState("Submit");
    const [message, setMessage] = useState('');
    const [formData, setFormData] = useState({
        fullname: '',
        subject: '',
        email: '',
        message: ''
    })
    const [err, setErr] = useState([])
    const onchange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Sending...");
        const response = await axios.post("https://myapi-portfolio.herokuapp.com/send", formData);
        if (response) {
            setStatus("Submit");
            setFormData({
                fullname: '',
                subject: '',
                email: '',
                message: ''
            })
            setMessage(response.data.status)
        }
        
        setErr(response.data)
   
    };

    return (
        <>
            <Grid container style={{ marginTop: '3%'}}>
                {
                    message && (<Alert className={classes.alert}>{message}</Alert>)
                    
                }
                {
                    err.length > 0 && (<Alert severity="warning" className={classes.alert}>{err}</Alert>)
                }
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    
                                <form className={classes.root} noValidate autoComplete="off">
                                    
                                    <TextField id="standard-basic" type="text" name="fullname" value={formData.fullname} label="Full name" onChange={onchange} required />
                                    <TextField id="standard-basic" type="text" name="subject" value={formData.subject} autoComplete="subject" label="Subject" onChange={onchange} md={4} required />
                                    <TextField id="standard-basic" type="email" name="email" value={formData.email} autoComplete="email" label="Email" md={4} onChange={onchange} required />
                                    <TextField
                                        id="standard-multiline-static"
                                        label="Message"
                                        multiline
                                        rows={8}
                                        value={formData.message}
                                        name="message"
                                        type="text"
                                        onChange={onchange}
                                        required
                                    />
                                    <Button className={classes.contactBtn} onClick={handleSubmit}>{status}</Button>
                                </form>
                      
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <h4 style={{ textAlign: 'center' }}>contact info</h4>
                    <Timeline>
                        <HeaderTimeline icon={<ContactsIcon />} />
                        <CustomTimeline title={'Adress'} description={'Qu salam rue el masjid N09'} />
                        <CustomTimeline title={'Phone'} description={'+212-606-587-853'} />
                        <CustomTimeline title={'Email'} description={'najjarmedd@gmail.com'} />
                        <Enddot />
                    </Timeline>
                </Grid>
            </Grid>
            <Grid container>
                <GoogleMap />
            </Grid>
        </>
    )
}

export default Contact
